import { BadgeProps } from '@setel/portal-ui';

export interface ILoyaltyCard {
  isPhysicalCard: boolean;
  isActive: boolean;
  isFailedActivation: boolean;
  overriddenToFrozen: boolean;
  overriddenToTemporarilyFrozen: boolean;
  isRemoved: boolean;
  isPointEarningEnabled: boolean;
  isPointRedemptionEnabled: boolean;
  id: string;
  cardNumber: string;
  userId: string;
  type: string;
  status: MemberStatus;
  issuedBy: string;
  vendorStatus: string;
  createdAt: Date;
  updatedAt: Date;
  isFrozenAt?: any;
  updatedBy: string;
  freezeReason?: any;
  vendorCardType: string;
  vendorCardTypeDescription: string;
  createdBy: string;
  isActivatedAt: Date;
  isFailedActivationAt?: any;
  isTemporarilyFrozenAt?: any;
  failedActivationReason?: any;
  pointRedeemableBalance: number;
  pointTotalBalance: number;
  provider?: string;
  redeemedPoints: number;
}

export enum LoyaltyCardVendorStatusesEnum {
  active = 'ACTIVE',
  issued = 'ISSUED',
  suspended = 'SUSPENDED',
  blocked = 'BLOCKED',
  fraudblocked = 'FRAUDBLOCKED',
  clpblocked = 'CLPBLOCKED',
  closed = 'CLOSED',
}

export enum LoyaltyCardStatusesEnum {
  issued = 'issued',
  active = 'active',
  frozen = 'frozen',
  temporarilyFrozen = 'temporarilyFrozen',
}

export enum MemberStatus {
  ISSUED = 'issued',
  ACTIVE = 'active',
  FROZEN = 'frozen',
  FROZEN_TEMP = 'temporarily_frozen',
}

export const loyaltyCardStatusColor: Record<MemberStatus, BadgeProps['color']> =
  {
    [MemberStatus.ACTIVE]: 'success',
    [MemberStatus.FROZEN]: 'grey',
    [MemberStatus.ISSUED]: 'success',
    [MemberStatus.FROZEN_TEMP]: 'lemon',
  } as const;
